import { all, fork } from 'redux-saga/effects';

import dataSagas from './data';
import trialPlanSagas from './trialPlan';

export default function* sagas() {
  yield all([fork(dataSagas), fork(trialPlanSagas)]);
}
